export default __webpack_public_path__ + "static/media/background4.cf64f13a.svg";